import { render, staticRenderFns } from "./SubmissionsQueue.vue?vue&type=template&id=8d322400&scoped=true"
import script from "./SubmissionsQueue.vue?vue&type=script&lang=js"
export * from "./SubmissionsQueue.vue?vue&type=script&lang=js"
import style0 from "./SubmissionsQueue.vue?vue&type=style&index=0&id=8d322400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d322400",
  null
  
)

export default component.exports